module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7zbLq"))).then(() => parcelRequire('iDabs'));